import PersonIcon from '@material-ui/icons/Person';
import { ChallengeWeekCreate, ChallengeWeekEdit } from './views';

export default {
  create: ChallengeWeekCreate,
  edit: ChallengeWeekEdit,
  icon: PersonIcon,
  name: 'challenge-week',
};
